module.exports = __webpack_public_path__ + "img/379.34ef3653.jpg";